import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/agents",
		component: lazy(() => import("./AgentsDashboardPage")),
	},
]);
